import React, { useEffect, useRef, useState } from 'react';
import PostPhotoGallery from 'components/PostPhotoGallery';
import RenderMentions from './RenderMentions';
import { Stack } from 'react-bootstrap';
import './styles.scss';

const AdvertisementPost: React.FC<any> = ({ post }) => {
	const [hasMore, setHasMore] = useState(false);
	const descriptionRef = useRef(null);

	const { image, description, title, link } = post;

	useEffect(() => {
		const element: any = descriptionRef?.current;
		if (element?.scrollHeight > element?.clientHeight) {
			setHasMore(true);
		}
	}, [post?.id]);

	const redirectToUrl = () => {
		if (link) window.open(link, '_blank', 'noopener,noreferrer');
	};

	return (
		<div className="social-post ad-post">
			<Stack className="social-post-inner">
				<div className="social-post-body">
					{[image]?.length > 0 && (
						<PostPhotoGallery mediaItems={[{ file: image, mediaType: 'image' }]} useS3Path={true} />
					)}
					{description && (
						<div className="post-content mb-0" onClick={() => redirectToUrl()}>
							<div className="post-profile d-flex align-items-md-center gap-2 gap-xxl-3">
								{title && <h4 className="fw-bold mb-2">{title}</h4>}
							</div>
							<p
								className={`description-truncated ${hasMore ? 'has-more' : ''}`}
								ref={descriptionRef}
							>
								<RenderMentions
									content={description || ''}
									taggedUsers={post?.taggedUsers}
									hashTags={post?.hashTags}
								/>
							</p>
						</div>
					)}
				</div>
			</Stack>
		</div>
	);
};

export default AdvertisementPost;
